import React, { Component } from "react";
import { browserHistory } from "react-router";
import PropTypes from "prop-types";
import translate from "react-i18next/dist/commonjs/translate";

class LogsSourceWidgetTableRow extends Component {
  constructor(props) {
    super(props);
    this.gotoLogSources = this.gotoLogSources.bind(this);
  }

  gotoLogSources(source) {
    browserHistory.push(
      `${global.applicationPath}/log-sources#${
        this.props.deviceGroup.groupName
      }`
    );
  }

  render() {
    const { t, rowKey } = this.props;
    return (
      <tr id={rowKey} key={rowKey} onClick={this.gotoLogSources}>
        <td>{this.props.deviceGroup.groupName}</td>
        <td>
          <i
            className={`icon-fixed-width fa fa-1 ${
              this.props.deviceGroup.isAllOnline
                ? "fa-check text-success"
                : "fa-close text-critical"
            }`}
          />
          <span className="text-strong">
            {this.props.deviceGroup.numberOfDevicesOnline}
          </span>{" "}
          {t("logSourceWidgetOf")} {this.props.deviceGroup.numberOfDevices}{" "}
          {t("logSourceWidgetOnline")}
        </td>
      </tr>
    );
  }
}

LogsSourceWidgetTableRow.propTypes = {
  deviceGroup: PropTypes.object.isRequired,
  rowKey: PropTypes.number.isRequired
};

export default translate("translations")(LogsSourceWidgetTableRow);



// WEBPACK FOOTER //
// ./src/dashboard/widgets/LogsSourceWidgetTableRow.js